var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoisture1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Feucht1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1037 -296)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--border-color, #c5d75d)",
    d: "M20,2.5A17.5,17.5,0,1,1,2.5,20,17.551,17.551,0,0,1,20,2.5M20,0A20,20,0,1,0,40,20,19.978,19.978,0,0,0,20,0Z",
    transform: "translate(1037 296)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--fill-color, #c5d75d)",
    d: "M25.45,21.525a7.876,7.876,0,1,1-15.75,0C9.7,17.15,17.575,5.9,17.575,5.9S25.45,17.15,25.45,21.525ZM21.075,18.9a2,2,0,1,0,2,2A2.151,2.151,0,0,0,21.075,18.9Z",
    transform: "translate(1039.425 297.475)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoisture1);
export default __webpack_public_path__ + "static/media/moisture-1.441827f2053f8ef73b8a67a5594e21da.svg";
export { ForwardRef as ReactComponent };